import { Spacer, Switch, Text, useColorMode, VStack } from '@chakra-ui/react';
import { t } from 'i18next';
import SecondaryLineButton from '../../../components/buttons/SecondaryLineButton';
import styled from '@emotion/styled';
import type { MemberType } from '../../types/ArtistType';

interface PhotoCardsSummaryRowProps {
  totalCount: number;
  collectedCount: number;
  isCheckedPhotoCardFilter: boolean;
  onChangePhotoCardFilter: () => void;
  currentMember: MemberType | null;
}

export default function PhotoCardsSummaryRow({
  totalCount,
  collectedCount,
  isCheckedPhotoCardFilter,
  onChangePhotoCardFilter,
  currentMember
}: PhotoCardsSummaryRowProps) {
  const calculatePercentageWithDecimal = (collectedCount: number, totalCount: number) => {
    if (!totalCount || totalCount === 0) return '0';
    const percentage = (collectedCount / totalCount) * 100;
    return percentage.toFixed(1).replace('.0', '');
  };
  const percentage = calculatePercentageWithDecimal(collectedCount, totalCount);
  const title =
    totalCount && currentMember ? `${currentMember.name} ${t('dBall')} ${percentage} %` : '';
  const { colorMode } = useColorMode();
  return (
    <div className="flex flex-row px-[24px] py-[12px]">
      <VStack align={'start'} spacing={'4px'}>
        <Text
          className="text-main-light-2 dark:text-main-dark-2"
          fontWeight={600}
          fontSize={'17px'}
          lineHeight={'20px'}
        >
          {title}
        </Text>
        <Text
          className="text-main-light-3 dark:text-main-dark-3"
          fontWeight={400}
          fontSize={'13px'}
          lineHeight={'16px'}
        >
          {t('CollectionsHomePage.CollectedPhotoCards', {
            count: collectedCount
          })}
        </Text>
      </VStack>
      <Spacer />
      {/* @ts-expect-error */}
      <SecondaryLineButton
        className={`border ${
          isCheckedPhotoCardFilter
            ? 'dark:border-primary-dark border-primary-light'
            : 'border-[rgba(0, 0, 0, 0.05)]'
        }`}
        text={
          <div
            className={`text-[14px] font-semibold leading-[17px] ${
              isCheckedPhotoCardFilter
                ? 'text-primary-light dark:text-primary-dark'
                : 'text-main-light-1 dark:text-main-dark-1'
            }`}
          >
            {t('CollectionsHomePage.MyPhotoCardsOnly')}
          </div>
        }
        rightElement={
          <CustomSwitchStyle
            size="sm"
            isChecked={isCheckedPhotoCardFilter}
            onChange={onChangePhotoCardFilter}
            colorMode={colorMode}
          />
        }
        style={{
          margin: '1.5px 0px',
          boxShadow: isCheckedPhotoCardFilter
            ? '0px 0px 5px 0px rgba(255, 118, 250, 0.2), 0px 0px 8px 0px rgba(161, 142, 255, 0.3)'
            : '',
          padding: '8px 14px',
          gap: '4px'
        }}
      />
    </div>
  );
}

export const CustomSwitchStyle = styled(Switch)<{ colorMode: string }>`
  .chakra-switch__track {
    background-color: ${(props) => {
      if (props.colorMode !== 'dark') return '';
      return props.isChecked ? '#303030' : '#303030 !important';
    }};
  }

  .chakra-switch__track .chakra-switch__thumb {
    background-color: ${(props) => (props.isChecked ? '' : '#ffffff !important')};
    background: ${(props) => (props.isChecked ? '' : '#ffffff !important')};
  }
`;